import $ from 'jquery';
import Cookies from 'js-cookie';

/*
 * List of Dom Elements
 */

const elements = {
  $cookieNotice: $('.js-cookie'),
  $cookieButton: $('.js-cookie-btn'),
};

function init() {
  // If cookie doesnt exist show banner
  if (!Cookies.get('ytl-foundation-cookie')) elements.$cookieNotice.addClass('is-visible');

  // Remove banner
  elements.$cookieButton.on('click', () => {
    elements.$cookieNotice.removeClass('is-visible');
    Cookies.set('ytl-foundation-cookie', 'true', {
      expires: 365,
      path: '/',
    });
  });
}

export default init;



// WEBPACK FOOTER //
// ./src/components/components/searches/_cookie/mando-ui.cookie.js